export default "__VITE_ASSET__CUICnV43__";